import * as zod from 'zod';

export const WeldPositionerState = zod.object({
  kind: zod.literal('WeldPositioner'),
  name: zod.string(),
  /**
   * Whether the trigger is currently asserted. Tracked by the device rather
   * than read back, because the trigger is an output: nothing reports it.
   */
  isRotating: zod.boolean(),
  /**
   * Latest sensor reads, or null where the cell has no such sensor wired.
   * Null is deliberately distinct from `false` — "no signal to read" and "read
   * and not satisfied" call for different operator messages.
   */
  isAligned: zod.boolean().nullable(),
  isComplete: zod.boolean().nullable(),
});

export type WeldPositionerState = zod.infer<typeof WeldPositionerState>;
